enum EnrollmentCode {
  Nyinnmelding = 0, // In CRM - sn_intradeskod: null med ""
  Innmelding = 1, // In CRM - sn_intradeskod: 1 med "Reinnmelding"
  ViaOverforing = 2, // In CRM - sn_intradeskod: 2 med "Ordinær"
  TolvMndFritak = 3, // In CRM - sn_intradeskod: 3 med "12 mnd fritak"
  SeksMndFritak = 7, // In CRM - sn_intradeskod: 7 med "6 mnd fritak (Byggmester og VBL)"
  AfterJuly2013Discount = 8, // In CRM - sn_intradeskod: 8 med "50 % rabatt etter 01.07.2013 (NHO KBS)"
}

export default EnrollmentCode;
